var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-breadcrumb"},[(_vm.breadcrumbItems)?_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbItems}}):_c('b-breadcrumb',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }